import classnames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { Preloader } from '@/components/Preloader';
import FounderCard from '@/components/Cards/FounderCard';
import { useGetInactiveFounders } from '@/query/queries/brand/useGetInactiveFounders';
import { useWindowSize } from '@/hooks/useWindowSize';

const FoundersAll = () => {
  const { t } = useTranslation('brands');
  const { innerWidth } = useWindowSize();

  const {
    data: founders,
    fetchNextPage,
    hasNextPage,
    isLoading,
  } = useGetInactiveFounders();

  const hasFounders = !!founders?.pages[0]?.total_count;

  return (
    <div className={classnames('founders-all')}>
      <h2 className="f-26 f-500">
        {t('founders.other.title')}{' '}
        {hasFounders && `(${founders.pages[0].total_count})`}
      </h2>

      <p className={classnames('founders-all__desc', 'f-16 f-400')}>
        {t('founders.other.description')}
      </p>

      {isLoading ? (
        <Preloader className="founders-all__preloader" />
      ) : hasFounders ? (
        <>
          <InfiniteScroll
            dataLength={Number(founders?.pages.length) || 0}
            next={fetchNextPage}
            hasMore={hasNextPage}
            scrollableTarget={innerWidth >= 1380 && 'main'}
            scrollThreshold={0.5}
            className="founders-all__list"
            loader={null}
          >
            {founders?.pages.map(page =>
              page.list.map(founder => (
                <FounderCard key={founder.id} founder={founder} hideFR />
              )),
            )}
          </InfiniteScroll>
        </>
      ) : (
        <div className="founders-all__empty">
          <span className="founders-all__empty-title f-16 f-400">
            {t('founders.other.no_founders')}
          </span>
        </div>
      )}
    </div>
  );
};

export default FoundersAll;
